import React, { Fragment, useEffect, useState } from "react";
import Humberg from "../../../elements/Humberg.jsx";

import { useDispatch, useSelector } from "react-redux";
import { allInvitesAction, clearErrors } from "../../../redux/actions/userActions.js";
import SingleInvite from "./SingleInvite.jsx";
import LoaderBlock from "../../loader/LoaderBlock.jsx";
import { toast } from "react-toastify";
import { UPDATE_USER_STATUS_RESET } from "../../../redux/constants/userConstant.js";



const InviteList = () => {



    const dispatch = useDispatch()

    const { loading, totalPages, userInvites } = useSelector((state) => state.allinvites)

    const { error, message } = useSelector(state => state.inviteUser)





    const [keyword, setKeyword] = useState('');
    const [status, setStatus] = useState('');
    const [perPage, setPerPage] = useState('20');
    const [page, setPage] = useState('1');



    useEffect(() => {
        const Headerlinkks = document.querySelectorAll(".headerLinks");
        const subLinks = document.querySelectorAll(".subLinks");
        const element = document.getElementById("dashboard")
        const subElement = document.getElementById("invites-list");


        Headerlinkks.forEach(el => el.classList.remove("activeHeaderLink"));
        subLinks.forEach(el => el.classList.remove("activeSubLink"));
        element?.classList.add("activeHeaderLink");
        console.log(subElement)
        subElement?.classList.add("activeSubLink");

        document.title = `Invites List - Admin Panel`;

    }, []);
    // Remove one quantity






    useEffect(() => {

        let query = {}
        if (keyword) query.keyword = keyword
        if (status) query.status = status
        if (perPage) query.perPage = perPage
        query.page = page

        dispatch(allInvitesAction(query))

    }, [keyword, status, perPage, page, dispatch])



    useEffect(() => {


        if (error) {
            toast.error(error)
            dispatch(clearErrors())
        }

        if (message) {
            dispatch({ type: UPDATE_USER_STATUS_RESET })
            dispatch(allInvitesAction())
        }


    }, [error, message, dispatch])




    return (
        <Fragment>
            <Humberg header="Dashboard" headerLink="/" children={"Invites List"} />
            <section className="p-[1.5vmax] mt-[1vmax]" >

                <div className="bg-white p-[2vmax] rounded-xl border border-gray-100 shadow-sm">
                    <div className="flex justify-between gap-[1.5vmax] items-center mb-[2vmax] flex-wrap">
                        {/* Search */}
                        <div className="w-full lg:w-[350px] flex items-center bg-gray-50 border border-gray-100 p-[0.7vmax_1vmax] rounded-lg focus-within:border-indigo-300 transition-colors">
                            <span className="text-gray-400 mr-[0.5vmax]" >
                                <i className="fa-solid fa-magnifying-glass"></i>
                            </span>
                            <input 
                                type="text" 
                                className="w-full bg-transparent outline-none text-[0.9vmax] font-medium text-gray-700 placeholder-gray-400" 
                                placeholder="Search By Email"
                                value={keyword}
                                onChange={(e) => {
                                    setKeyword(e.target.value)
                                    setPage(1)
                                }}
                            />
                        </div>

                        {/* Filters */}
                        <div className="flex items-center gap-[1vmax] flex-wrap">
                            <span className="text-gray-500 font-medium text-[0.9vmax]">Filter by:</span>
                            
                            {/* Status Filter */}
                            <div className="relative bg-gray-50 border border-gray-100 rounded-lg focus-within:border-indigo-300 transition-colors">
                                <select 
                                    className="pl-[1vmax] pr-[2vmax] py-[0.7vmax] text-[0.9vmax] font-medium text-gray-700 outline-none bg-transparent appearance-none"
                                    value={status}
                                    onChange={(e) => {
                                        setStatus(e.target.value)
                                        setPage(1)
                                    }}
                                >
                                    <option value="">Status</option>
                                    <option value="ACTIVE">Active</option>
                                    <option value="CANCELLED">Cancelled</option>
                                    <option value="EXPIRED">Expired</option>
                                    <option value="COMPLETED">Completed</option>
                                </select>
                                <span className="absolute right-[0.7vmax] top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
                                    <i className="fa-solid fa-chevron-down text-xs"></i>
                                </span>
                            </div>

                            {/* Per Page */}
                            <div className="relative bg-gray-50 border border-gray-100 rounded-lg focus-within:border-indigo-300 transition-colors">
                                <select 
                                    className="pl-[1vmax] pr-[2vmax] py-[0.7vmax] text-[0.9vmax] font-medium text-gray-700 outline-none bg-transparent appearance-none"
                                    value={perPage}
                                    onChange={(e) => {
                                        setPerPage(e.target.value)
                                        setPage(1)
                                    }}
                                >
                                    <option value="1">1</option>
                                    <option value="5">5</option>
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                </select>
                                <span className="absolute right-[0.7vmax] top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
                                    <i className="fa-solid fa-chevron-down text-xs"></i>
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="w-full overflow-x-auto">
                        <div className="min-w-[1000px] border border-gray-200 rounded-xl overflow-hidden shadow-sm bg-white mb-[1.5vmax]">
                            {/* Header */}
                            <div 
                                className="grid bg-gray-50 py-[1vmax] items-center border-b border-gray-200"
                                style={{ gridTemplateColumns: 'minmax(0, 0.5fr) minmax(0, 2fr) minmax(0, 0.7fr) minmax(0, 1fr) minmax(0, 1.5fr) minmax(0, 1.5fr) minmax(0, 1fr)' }}
                            >
                                <div className="text-center text-[#4c4c5c] uppercase text-[0.8vmax] font-bold" >
                                    No.
                                </div>
                                <div className="px-[1vmax] text-[#4c4c5c] uppercase text-[0.8vmax] font-bold" >
                                    Email
                                </div>
                                <div className="text-center text-[#4c4c5c] uppercase text-[0.8vmax] font-bold" >
                                    Role
                                </div>
                                <div className="text-center text-[#4c4c5c] uppercase text-[0.8vmax] font-bold" >
                                    Admin
                                </div>
                                <div className="text-center text-[#4c4c5c] uppercase text-[0.8vmax] font-bold" >
                                    Invited At
                                </div>
                                <div className="text-center text-[#4c4c5c] uppercase text-[0.8vmax] font-bold" >
                                    Expires At
                                </div>
                                <div className="text-center text-[#4c4c5c] uppercase text-[0.8vmax] font-bold" >
                                    Status
                                </div>
                            </div>

                            {/* Rows */}
                            {loading ?
                                <LoaderBlock />
                                :
                                userInvites?.length > 0 ?
                                    userInvites.map((invite, index) =>
                                        <SingleInvite key={invite.id} invite={invite} index={index} totalinvites={userInvites?.length} />
                                    )
                                    :
                                    <div className="text-center text-[1.5vmax] text-gray-400 py-[3vmax]" >
                                        No data found
                                    </div>
                            }
                        </div>
                    </div>
                </div>

            </section>
            {totalPages > 1 && (
                <div className="flex gap-[1vmax] justify-center mt-[2vmax]">

                    {/* Prev button */}
                    <button
                        className="pagination-btn"
                        disabled={page === 1}
                        onClick={() => setPage(page - 1)}
                    >
                        Prev
                    </button>

                    {/* --- SMART PAGINATION START --- */}
                    {(() => {
                        const pages = [];
                        const maxVisible = 3; // number of pages to show around current page

                        const addPage = (p) => {
                            pages.push(
                                <button
                                    key={p}
                                    className={`pagination-btn ${page === p ? "active" : ""}`}
                                    onClick={() => setPage(p)}
                                >
                                    {p}
                                </button>
                            );
                        };

                        // Always show First Page
                        addPage(1);

                        // Left dots
                        if (page > maxVisible + 2) {
                            pages.push(<span key="dots-left">...</span>);
                        }

                        // Middle pages (dynamic)
                        for (
                            let p = Math.max(2, page - maxVisible);
                            p <= Math.min(totalPages - 1, page + maxVisible);
                            p++
                        ) {
                            addPage(p);
                        }

                        // Right dots
                        if (page < totalPages - (maxVisible + 1)) {
                            pages.push(<span key="dots-right">...</span>);
                        }

                        // Always show Last Page
                        if (totalPages > 1) {
                            addPage(totalPages);
                        }

                        return pages;
                    })()}
                    {/* --- SMART PAGINATION END --- */}

                    {/* Next button */}
                    <button
                        className="pagination-btn"
                        disabled={page === totalPages}
                        onClick={() => setPage(page + 1)}
                    >
                        Next
                    </button>

                </div>
            )}

        </Fragment>
    );
};

export default InviteList;
